import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { map } from 'rxjs/operators';
import { Asset } from '../models';

@Injectable({ providedIn: 'root' })
export class AssetService {

  private path = '/assets';

  constructor(private http: AlloxApiService) { }

  public getDefault() {
    return this.http.get<[]>(this.path + '/default').pipe(
      map(objs => objs.map(obj => new Asset(obj))),
    );
  }
}
